import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, Observable } from 'rxjs';
import { DriftConfiguration } from 'src/app/models/configuration.interface';
import { ConfigurationService } from '../../services/configuration.service';
import { CommentRequest, Task, TaskComment, TaskHistory, TaskRequest } from '../models/task';

@Injectable()
export class WorkspaceTaskService {
  private readonly tasksUrl = '/tasks';
  private readonly workspaceUrl = '/workspace';
  private config!: DriftConfiguration;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly configurationService: ConfigurationService
  ) {
    //No unsub required
    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  private get baseApiUrl() {
    return `${this.config.driftApi}${this.workspaceUrl}`;
  }

  public getTasks(workspaceId: string): Observable<Task[]> {
    const path = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}`;
    return this.httpClient.get<Task[]>(path);
  }

  public getTaskById(workspaceId: string, taskId: string): Observable<Task> {
    const path = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}/${taskId}`;
    return this.httpClient.get<Task>(path);
  }

  public createTask(workspaceId: string, data: TaskRequest): Observable<void> {
    const path = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}`;
    return this.httpClient.post<void>(path, data);
  }

  public updateTask(workspaceId: string, taskId: string, data: TaskRequest): Observable<void> {
    const path = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}/${taskId}`;
    return this.httpClient.put<void>(path, data);
  }

  public deleteTask(workspaceId: string, taskId: string): Observable<void> {
    const path = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}/${taskId}`;
    return this.httpClient.delete<void>(path);
  }

  public postComment(workspaceId: string, taskId: string, data: CommentRequest): Observable<void> {
    const path = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}/${taskId}/comments`;
    return this.httpClient.post<void>(path, data);
  }

  public updateComment(workspaceId: string, taskId: string, commentId: string, data: CommentRequest): Observable<void> {
    const path = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}/${taskId}/comments/${commentId}`;
    return this.httpClient.put<void>(path, data);
  }

  public deleteComment(workspaceId: string, taskId: string, commentId: string): Observable<void> {
    const path = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}/${taskId}/comments/${commentId}`;
    return this.httpClient.delete<void>(path);
  }

  public getComments(workspaceId: string, taskId: string): Observable<TaskComment[]> {
    const url = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}/${taskId}/comments`;
    return this.httpClient.get<TaskComment[]>(url);
  }

  public getTaskHistory(workspaceId: string, taskId: string): Observable<TaskHistory[]> {
    const url = `${this.baseApiUrl}/${workspaceId}${this.tasksUrl}/${taskId}/history`;
    return this.httpClient.get<TaskHistory[]>(url);
  }
}
